import React, { useCallback, useEffect, useState } from 'react'
import { noop } from 'utils'
import { H3 } from 'components/typography'
import Modal from './Modal'
import styles from './TestImageModal.module.css'

const DEFAULT_TEST_IMAGES = [
  {
    location: 'https://picsum.photos/id/180/700/700',
    thumbnail: 'https://picsum.photos/id/180/200/200',
    title: 'MacBook'
  },
  {
    location: 'https://picsum.photos/id/486/600/600',
    thumbnail: 'https://picsum.photos/id/486/200/200',
    title: 'Máquina de escribir'
  },
  {
    location: 'https://picsum.photos/id/532/600/600',
    thumbnail: 'https://picsum.photos/id/532/200/200',
    title: 'iMac'
  }
]

function TestImageModal({ onSelect = noop, onCancel = noop }) {
  const [testImages, setTestImages] = useState(DEFAULT_TEST_IMAGES)

  const handleImageSelect = useCallback(
    image => {
      onSelect({
        location: image.location,
        id: 'test',
        thumbnail: image.thumbnail
      })
    },
    [onSelect]
  )

  useEffect(() => {
    fetch(
      'https://mundoestudiante-data.netlify.app/classfy-profe-fotos-ejemplo.json'
    )
      .then(res => {
        if (!res.ok)
          throw new Error('Error fetching classfy-profe-fotos-ejemplo data')
        return res.json()
      })
      .then(setTestImages)
      .catch(_ => null)
  }, [])

  return (
    <Modal
      hideOkButton
      hideCancelButton
      showCloseIcon
      onCancel={onCancel}
      showActions={false}
    >
      <div className={styles.container}>
        <H3>Selecciona una imagen de prueba</H3>
        <div className={styles.imageGrid}>
          {testImages.map((image, index) => (
            <div
              key={index}
              className={styles.imageItem}
              onClick={() => handleImageSelect(image)}
            >
              <img
                src={image.thumbnail}
                alt={image.title}
                className={styles.image}
                loading='lazy'
              />
              <div className={styles.imageOverlay}>
                <span className={styles.imageTitle}>{image.title}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  )
}

export default TestImageModal
